export const SA_USER_SIGN_IN = "SA_USER_SIGN_IN";
export const SA_USER_SIGN_OUT = "SA_USER_SIGN_OUT";